module.exports = __webpack_public_path__ + "static/media/honda_asistencia_icon.4ecf4064.svg";